import { z } from "zod";

export const EmployeePersonalDetailSchema = z.object({
    id: z.number(),
    employeeId: z.string().optional(),
    ccEmail: z.string().optional(),
    empName: z.string(),
    firstName: z.string().optional(),
    lastName: z.string().optional(),
    gender: z.string().optional(),
    designation: z.string().optional(),
    department: z.string().optional(),
    departmentId: z.union([z.number(), z.string()]).nullish(),
    managerName: z.string().optional(),
    photoPath: z.string().optional(),
    employeeType: z.string().optional(),
    employeeSubType: z.string().optional(),
    currentLocation: z.string().optional(),
    noticePeriodDays: z.number().optional(),
    doj: z.string().optional(),
});

export type EmployeePersonalDetail = z.infer<typeof EmployeePersonalDetailSchema>;

export const EmployeeProfileResponseSchema = z.object({
    statusCode: z.number().optional(),
    message: z.string().optional(),
    data: z.object({
        personalDetail: EmployeePersonalDetailSchema,
    }),
});

export type EmployeeProfileResponse = z.infer<typeof EmployeeProfileResponseSchema>;
